import React, { useState, useEffect } from "react";

export default function ToastNotification({ message, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 2000);

    return () => clearTimeout(timeout);
  }, [onClose]);

  return (
    <div
      className={`fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="flex justify-between items-center">
        <div>{message}</div>
        <button
          onClick={() => {
            setIsVisible(false);
            onClose();
          }}
        >
          &times;
        </button>
      </div>
    </div>
  );
}
